import { createStore } from 'vuex';

export default createStore({
  state: {
    userData: {
      id: null,
      token: null,
      role: null,
      banners: {
        program: null,
        partner: null,
        participant: null,
        speaker: null,
        exhibitor: null,
      },
      inbox: {
        notification: 0,
        messages: 0,
        unreadChat: 0,
        unApproveMM: 0,
      },
    },
    // @domain {String} - адрес API сервера
    // @exhId {Number} - ID мероприятия выбранного пользователем
    axios: {
      // domain: 'https://dev.expoup.ru',
      domain: 'https://app.delo-spectechniki.ru',
      version: 'v1',
      lang: 'ru',
      // Справочник языков мероприятия из конфига: { ru: 'Рус', en: 'Eng' }.
      // Пустой — конфиг про языки ничего не сказал, ведём себя как раньше.
      languageList: {},
      // exId: '3',
      exId: null,
      isConnected: true,
    },
    lastUrl: null,
    // Что это?
    infoMessage: {
      type: null,
      text: null,
    },
    mainTitle: {},
    pageTitle: null,
    // Очередь коротких сообщений над нижней панелью. В сторе, а не в
    // компоненте: сообщение кладут перед переходом, а читают уже на другом
    // экране — например уводя человека создавать визитку.
    toasts: [],
    lastToastId: 0,
    // получать разрешение на использование модулей через конфиг
    includeApps: {
      mm: false, // ММ для участников (посетителей)
      partnersMM: false, // ММ для партнёров (экспонентов)
      messenger: false,
      businessCard: false, // обмен визитками
    },
    navigations: {
      showBtnToEventList: true,
      showBtnAsideMenu: true,
      showBottomNav: true,
    },
    system: {
      exhib_time_start: null,
      exhib_time_end: null,
      zone_UTC: 'UTC+0',
      setZone_UTC: false,
      timer_update_ts: null,
      timer_app_id: null,
      // TO DO remove timer_program_id
      timer_program_id: null,
      updating_id: null,
      progressVal: 0,
    },
    scaner: {
      last_camera_id: null,
      isSending: false,
      isNeedSend: false,
    },
    // Ссылки /{exhId}/{lang}/... — см. docs/deep-links.md
    deepLink: {
      // Прятать окно «получить билет» (system.new_version_message), если
      // приложение открыли по ссылке. Только на этот запуск, как «Позже».
      hideNotice: true,
      // Запуск начался с ссылки. Ставит beforeEnter маршрута deepLink.
      openedByLink: false,
    },
  },
  getters: {
    getUserID(state) {
      return state.userData.id;
    },
    getUserRole(state) {
      return state.userData.role;
    },
    getExhId(state) {
      if (state.axios.exId === null) {
        const setId = localStorage.getItem('exhID') || null;
        // TODO переделать
        state.axios.exId = setId ? parseInt(setId, 10) : null;
      }
      return state.axios.exId;
    },
    getLang(state) {
      return state.axios.lang;
    },
    getLanguageList(state) {
      return state.axios.languageList;
    },
    isNoticeHiddenByLink(state) {
      return state.deepLink.hideNotice && state.deepLink.openedByLink;
    },
    // eslint-disable-next-line no-unused-vars
    apiDomain(state) {
      return state.axios.domain;
    },
    apiPath(state) {
      return `${state.axios.domain}/wapi/${state.axios.version}`;
    },
    // eslint-disable-next-line no-unused-vars
    apiBasePath(state, getters) {
      return `${getters.apiPath}/${state.axios.lang}/${state.axios.exId}`;
    },
    apiProgramsPath(state, getters) {
      return `${getters.apiBasePath}/program`;
    },
    apiStaticPage(state, getters) {
      return `${getters.apiBasePath}/....`;
    },
    isConnected(state) {
      return state.axios.isConnected;
    },
    isAuth(state) {
      return !!state.userData.token;
    },
    getToken(state) {
      return state.userData.token;
    },
    getLastUrl(state) {
      return state.lastUrl;
    },
    getNewNotificationCount(state) {
      return state.userData.inbox.notification;
    },
    getUnreadChatCount(state) {
      return state.userData.inbox.unreadChat;
    },
    getUnApproveMeetingCount(state) {
      return state.userData.inbox.unApproveMM;
    },
    getMainTitle(state, getters) {
      return state.mainTitle[getters.getLang];
      // return state.mainTitle;
    },
    getPageTitle(state) {
      return state.pageTitle;
    },
    getToasts(state) {
      return state.toasts;
    },
    // Что это?
    getInfoMessages(state) {
      if (state.infoMessage.text) {
        return { type: state.infoMessage.type, text: state.infoMessage.text };
      }
      return null;
    },
    // ===Banner===
    getBannerProgramTs(state) {
      return state.userData.banners.program;
    },
    getBannerPartnerTs(state) {
      return state.userData.banners.partner;
    },
    getBannerParticipantTs(state) {
      return state.userData.banners.participant;
    },
    getBannerExhibitorTs(state) {
      return state.userData.banners.exhibitor;
    },
    getBannerSpeakerTs(state) {
      return state.userData.banners.speaker;
    },
    // =/=Banner=/=
    // ===System===
    timeZone(state) {
      return state.system.zone_UTC;
    },
    getTimerUpdate(state) {
      return state.system.timer_update_ts;
    },
    getUpdatingID(state) {
      return state.system.updating_id;
    },
    getAppTimer(state) {
      return state.system.timer_app_id;
    },
    // TO DO remove timer_program_id
    getProgramTimer(state) {
      return state.system.timer_program_id;
    },
    isProgressVal(state) {
      return state.system.progressVal;
    },
    exhTimeStart(state) {
      return state.system.exhib_time_start;
    },
    exhTimeEnd(state) {
      return state.system.exhib_time_end;
    },
    isSetTime_UTC(state) {
      return state.system.setZone_UTC;
    },
    getTime_UTC(state) {
      if (state.system.setZone_UTC) {
        // знак уже содержится в самом числе, поэтому для отрицательного
        // смещения его добавлять не нужно — иначе получается 'UTC--5'
        const offset = Number(state.system.zone_UTC);
        if (Number.isNaN(offset)) return 'UTC+0';
        return `UTC${offset >= 0 ? '+' : ''}${offset}`;
      }
      return 'UTC+0';
    },
    // =/=System=/=
    // ===Navigations===
    isVisibleBtnMenu(state) {
      return state.navigations.showBtnAsideMenu;
    },
    isVisibleBtnToEventList(state) {
      return state.navigations.showBtnToEventList;
    },
    isVisiblBottomNav(state) {
      return state.navigations.showBottomNav;
    },
    // =/=Navigations=/=
    // === apps ===
    isMM(state) {
      // return false;
      return state.includeApps.mm || false;
    },
    isPartnersMM(state) {
      // return false;
      return state.includeApps.partnersMM || false;
    },
    isMessenger(state) {
      return state.includeApps.messenger || false;
    },
    // Модуль визиток целиком: своя визитка, коллекция чужих и обмен. Флагом
    // закрыты все точки входа, чтобы вырезание модуля у клиента сводилось к
    // одной строке в includeApps, а не к правке каждого экрана.
    isBusinessCard(state) {
      return state.includeApps.businessCard || false;
    },
    // =/= apps =/=
    // === scaner ===
    isScanerSending(state) {
      return state.scaner.isSending;
    },
    isScanerNeedSend(state) {
      return state.scaner.isNeedSend;
    },
    lastCamera(state) {
      return state.scaner.last_camera_id;
    },
    // =/= scaner =/=
  },
  mutations: {
    setUserID(state, value) {
      state.userData.id = value;
    },
    setUserRole(state, value) {
      state.userData.role = value;
    },
    setExhId(state, value) {
      localStorage.setItem('exhID', value);
      state.axios.exId = value ? parseInt(value, 10) : null;
    },
    // Сообщение живёт до первого показа: экран, который его вывел,
    // обязан вызвать clearInfoMessage, иначе оно всплывёт снова.
    setInfoMessage(state, { type, text }) {
      state.infoMessage.type = type || 'info';
      state.infoMessage.text = text || null;
    },
    clearInfoMessage(state) {
      state.infoMessage.type = null;
      state.infoMessage.text = null;
    },
    // type: 'info' по умолчанию, 'danger' для неудач, 'success' для удач.
    // sticky — не гаснуть по таймеру: так живёт сообщение об отсутствии связи,
    // это состояние, а не событие.
    // tag — метка единственности: тост с такой меткой в очереди всегда один,
    // иначе десять оборвавшихся запросов дали бы десять сообщений.
    pushToast(state, {
      text, type, sticky, tag, icon,
    }) {
      if (!text) return;
      if (tag) state.toasts = state.toasts.filter((toast) => toast.tag !== tag);
      state.lastToastId += 1;
      state.toasts.push({
        id: state.lastToastId,
        text,
        type: type || 'info',
        sticky: sticky === true,
        tag: tag || null,
        // без своей иконки берётся та, что положена роду сообщения
        icon: icon || null,
      });
    },
    removeToast(state, id) {
      state.toasts = state.toasts.filter((toast) => toast.id !== id);
    },
    removeToastByTag(state, tag) {
      state.toasts = state.toasts.filter((toast) => toast.tag !== tag);
    },
    setOpenedByLink(state, value) {
      state.deepLink.openedByLink = value;
    },
    setLang(state, value) {
      state.axios.lang = value;
    },
    setLanguageList(state, value) {
      state.axios.languageList = value && typeof value === 'object' ? { ...value } : {};
    },
    updConnectionStatus(state, value) {
      state.axios.isConnected = value;
    },
    setToken(state, value) {
      state.userData.token = value;
    },
    setLastUrl(state, { name, params }) {
      state.lastUrl = { name, params };
    },
    setNewNotificationCount(state, value) {
      state.userData.inbox.notification = value > 0 ? value : 0;
    },
    setUnreadChatCount(state, value) {
      state.userData.inbox.unreadChat = value > 0 ? value : 0;
    },
    setUnApproveMeetingCount(state, value) {
      state.userData.inbox.unApproveMM = value > 0 ? value : 0;
    },
    setMainTitle(state, value) {
      state.mainTitle[value.lang] = value.text;
      // state.mainTitle = value;
    },
    setPageTitle(state, value) {
      state.pageTitle = value;
    },
    // ===Banner===
    setBannerProgramTs(state, value) {
      state.userData.banners.program = value;
    },
    setBannerPartnerTs(state, value) {
      state.userData.banners.partner = value;
    },
    setBannerParticipantTs(state, value) {
      state.userData.banners.participant = value;
    },
    setBannerExhibitorTs(state, value) {
      state.userData.banners.exhibitor = value;
    },
    setBannerSpeakerTs(state, value) {
      state.userData.banners.speaker = value;
    },
    // =/=Banner=/=
    // ===System===
    setTimerUpdate(state, value) {
      state.system.timer_update_ts = value;
    },
    setUpdatingID(state, value) {
      state.system.updating_id = value;
    },
    setAppTimer(state, value) {
      state.system.timer_app_id = value;
    },
    // TO DO remove timer_program_id
    setProgramTimer(state, value) {
      state.system.timer_program_id = value;
    },
    setProgressVal(state, value) {
      state.system.progressVal = value;
    },
    setExhTimeStart(state, value) {
      state.system.exhib_time_start = value;
    },
    setExhTimeEnd(state, value) {
      state.system.exhib_time_end = value;
    },
    setTime_UTC(state, value) {
      state.system.setZone_UTC = value !== null;
      state.system.zone_UTC = value;
    },
    // =/=System=/=
    // ===set Navigations===
    visibleBtnMenu(state, value) {
      state.navigations.showBtnAsideMenu = value;
    },
    visibleBtnToEventList(state, value) {
      state.navigations.showBtnToEventList = value;
    },
    visiblBottomNav(state, value) {
      state.navigations.showBottomNav = value;
    },
    // =/=set Navigations=/=
    // === apps ===
    switchMM(state, value) {
      state.includeApps.mm = value === true;
    },
    switchPartnersMM(state, value) {
      state.includeApps.partnersMM = value === true;
    },
    switchMessenger(state, value) {
      state.includeApps.messenger = value === true;
    },
    // =/= apps =/=
    // === scaner ===
    updScanerSending(state, value) {
      state.scaner.isSending = value;
    },
    updScanerNeedSend(state, value) {
      state.scaner.isNeedSend = value;
    },
    lastCamera(state, value) {
      state.scaner.last_camera_id = value;
    },
    // =/= scaner =/=
  },
  actions: {
  },
  modules: {
  },
});
